<template lang='pug'>
//- 刪除翻譯紀錄區塊
div(:class='$style[`cc-popbox-delete-warning`]')
  div(:class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-delete-info`]') 刪除此翻譯紀錄？
    span.font-medium(:class='$style[`cc-popbox-delete-info-tips`]') 提醒您，刪除後無法復原。
    div(:class='$style[`cc-content-btn-area`]')
      button(
        title='取消'
        tabindex='0' aria-label='取消取消'
        :class='[$style[`cc-content-btn`], $style[`cc-content-btn-cancel`]]'
        @click='handleClickToCancel')
        span 取消

      button(
        title='刪除'
        tabindex='0' aria-label='刪除此翻譯紀錄'
        :class='[$style[`cc-content-btn`], $style[`cc-content-btn-delete`]]'
        @click='handleClickToDelete')
        span 刪除

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconWarn from '../../icon/Warn';
import GlobalEmitter from 'tiny-emitter/instance';

import {
  deleteTranslatorResult,
} from '../../../js/restapi';

export default {
  components: {
    IconWarn,
  },

  props: {
    id: {
      type: Number,
      default: null,
    },
    forId: {
      type: Number,
      default: null,
    },
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDeleteTranslationStatus: 'global/POPDELETE_TRANSLATION_STATUS',
    }),

    handleClickToCancel() {
      this.changePopDeleteTranslationStatus({
        active: false,
        id: '',
        forId: '',
      });
    },

    handleClickToDelete() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const UPDATE_DATA = {
        id: `${this.id}`,
      };

      deleteTranslatorResult('', {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
        data: JSON.stringify(UPDATE_DATA),
      })
        .then((/* response */) => {
          console.log('刪除翻譯紀錄 成功!');
          this.changePopBoxStatus({
            active: true,
            include: 'sendDelete',
          });
          this.changePopDeleteTranslationStatus({
            active: false,
            id: '',
            forId: '',
          });

          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
          }, this.POP_DURATION);

          GlobalEmitter.emit('delete-translation', this.forId);
        })
        .catch((error) => {
          console.error('刪除翻譯紀錄 失敗！', error.message);
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popDeleteWarning.scss';
</style>
